module.exports = __webpack_public_path__ + "img/icon_blue-big_fork-knife.3a4bf39f.svg";